import { Messages } from '../../../../codegen/Localize';
import { runFlow } from '../../../../flow/actions/RunFlowReduxAction';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IRunFlowAction } from '../../../../ts/ServerApi/types/actionNames';
import { appStore } from '../../../AppStore';
import { hasRunNowPermission } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RunFlowEntityAction: IEntityAction<IContentInfo<'flow'>, IRunFlowAction> = {
  name: EntityActionNames.RunNow,
  translateName: Messages.runNow,
  isVisible: () => true,
  isClickable: (availableActions: IRunFlowAction) => {
    return hasRunNowPermission(appStore.getState()) && !!(availableActions && availableActions.runFlow);
  },
  createReduxAction: (targetItems: IContentInfo[]) => runFlow(targetItems)
};
